import {toastError, toastSuccess} from "../../component/shared/toast/Toast";
import i18n from "../../config/i18n";
import {getSafeBackendErrorMessage} from "../../util/utils";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import CfgAttributeService, {ICfgAttributeCreateEdit} from "../../api/cfgAttributeService";

export const getCfgAttributes =
    createAsyncThunk(`${SliceNames.CFG_ATTRIBUTE}/getCfgAttributes`,
        async (_, thunkAPI) => {
            try {
                const res = await CfgAttributeService.fetchAttributes()

                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const createAttribute =
    createAsyncThunk(`${SliceNames.CFG_ATTRIBUTE}/createAttribute`,
        async (req: { attribute: ICfgAttributeCreateEdit, handleCloseDialog: () => void }, thunkAPI) => {
            try {
                const res = await CfgAttributeService.createAttribute(req.attribute)
                req.handleCloseDialog()
                toastSuccess(i18n.t('changes_saved_success'))
                return res.data
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })

export const editAttribute =
    createAsyncThunk(`${SliceNames.CFG_ATTRIBUTE}/editAttribute`,
        async (req: { attribute: ICfgAttributeCreateEdit, handleCloseDialog: () => void }, thunkAPI) => {
            try {
                const res = await CfgAttributeService.editAttribute(req.attribute)
                req.handleCloseDialog()
                toastSuccess(i18n.t('changes_saved_success'))
                return res.data
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })